import { render, staticRenderFns } from "./SkinCare.vue?vue&type=template&id=77419146&"
import script from "./SkinCare.vue?vue&type=script&lang=js&"
export * from "./SkinCare.vue?vue&type=script&lang=js&"
import style0 from "./SkinCare.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports